import { Subscription } from 'rxjs';
import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';
import { SelectInputHelper } from 'src/app/shared/helpers/select-input.helper';
import { SelectInputData } from 'src/app/shared/interfaces/select-input-data.interface';
import { BrowserNtfHistoryService } from 'src/app/shared/services/browser-ntf/browser-ntf-history.service';
import { DialogService } from 'src/app/shared/services/dialog.service';
import { CompanyDataService } from 'src/app/view-company/service/company-data.service';
import { AppThemeService } from '../../services/app-theme.service';
import { ContextDataService } from '../../services/context.data-service';
import { ContextService } from '../../services/context.service';
import { ContextData, ContextType, FestiveTheme } from '../../services/models/context.data';
import { RWDService } from '../../services/rwd.service';
import { BrowserNtfPanelComponent } from '../browser-ntf-panel/browser-ntf-panel.component';
import { MobileOtherActionsComponent } from '../mobile-other-actions/mobile-other-actions.component';

@Component({
  selector: 'app-top-bar',
  templateUrl: './top-bar.component.html',
  styleUrls: ['./top-bar.component.scss']
})
export class TopBarComponent implements OnInit, OnChanges, OnDestroy {
  @Input() contextData!: ContextData;

  public estateOptions: SelectInputData<string>[] = [];
  public contextType: ContextType = ContextType.ESTATE;

  public estateControl = new FormControl(null);
  public festiveTheme: FestiveTheme | null = null;
  public showCompanyId = false;
  public estates: EstateData[] = [];
  public unreadNotificationsCount = 0;

  private subscription$ = new Subscription();

  CT = ContextType;

  constructor(
    public rwdService: RWDService,
    public companyDS: CompanyDataService,
    private ctxDS: ContextDataService,
    private dialogService: DialogService,
    private ctxSrv: ContextService,
    private appThemeService: AppThemeService,
    private browserNtfHistoryService: BrowserNtfHistoryService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subscription$.add(
      this.ctxDS.currentEstate$.subscribe((x) => this.estateControl.patchValue(x?.id, { emitEvent: false }))
    );
    this.subscription$.add(
      this.estateControl.valueChanges.subscribe((x) => {
        this.ctxSrv.setEstate(x);
        this.router.navigate(['/dashboard']);
      })
    );

    this.subscription$.add(
      this.ctxDS.context$.subscribe((c) => {
        this.contextType = c || this.contextData.type;
        this.showCompanyId = this.contextType === ContextType.COMPANY && this.ctxDS.isUserSuperAdmin;
      })
    );

    this.subscription$.add(this.appThemeService.getFestiveTheme$().subscribe((theme) => (this.festiveTheme = theme ?? null)));
    this.subscription$.add(
      this.browserNtfHistoryService.unreadCount$.subscribe((count) => (this.unreadNotificationsCount = count))
    );
    void this.browserNtfHistoryService.loadInitial();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.contextData) {
      const value: EstateData[] = changes.contextData.currentValue.estates;
      this.estates = value.sort((x, y) => x.name.localeCompare(y.name));
      // TODO: Add localisation - skippable by now, because only superadmin can see hidden estates
      this.estateOptions = SelectInputHelper.fromObjects(this.estates, (e) => e.name + (e.hidden ? ' (ukryta)' : ''), 'id');
    }
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  public showNavigation(): void {
    this.rwdService.openNavPanel();
  }

  public showMobileActions(): void {
    this.dialogService.openPanelDialog(
      MobileOtherActionsComponent,
      {
        estateControl: this.estateControl,
        contextType: this.contextType,
        contextData: this.contextData,
        estates: this.estates
      },
      {
        width: '60%',
        height: '90%',
        minWidth: '200px',
        position: {
          right: '0%',
          top: '65.5px'
        },
        panelClass: 'mobile'
      }
    );
  }

  public showBrowserNotifications(): void {
    this.dialogService.openPanelDialog(
      BrowserNtfPanelComponent,
      { estates: this.estates },
      {
        width: this.rwdService.isSmallDevice ? '100%' : '570px',
        maxWidth: this.rwdService.isSmallDevice ? '100%' : '570px',
        minWidth: this.rwdService.isSmallDevice ? '0' : '570px',
        height: '100vh',
        maxHeight: '100vh',
        panelClass: ['unpadded-dialog', 'browser-ntf-panel-dialog'],
        autoFocus: false
      }
    );
  }

  public get unreadNotificationsLabel(): string {
    return this.unreadNotificationsCount > 99 ? '99+' : this.unreadNotificationsCount.toString();
  }
}
